// extracted by mini-css-extract-plugin
export default {"keywords":"Settings_keywords__iUMen","each_keyword":"Settings_each_keyword__bW0uD","keywords_box":"Settings_keywords_box__ZgSxw","settings":"Settings_settings__Iy1BE"};